<template>
    <v-card flat class="">
        <v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
            :server-items-length="table.totalItems" :loading="table.loading" dense class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Pengembangan Diri</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" persistent max-width="800px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="add()">
                                Tambah Data
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h6">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field v-model="form.editedItem.nama" label="Nama:" dense outlined
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field v-model="form.editedItem.nip" label="NIP:" dense outlined
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field v-model="form.editedItem.masa_kerja" type="number"
                                            label="Masa Kerja (Tahun) :" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-autocomplete v-model="form.editedItem.id_dokdiknis" :items="form.dokdikniss"
                                            outlined dense label="Dokdiknis/Pembimbing :" item-text="nama"
                                            item-value="id" hide-details></v-autocomplete>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field v-model="form.editedItem.ijazah"
                                            label="Nama Pelatihan/Seminar/Workshop :" dense outlined
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field v-model="form.editedItem.sip" label="Nomor Sertifikat :" dense
                                            outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <span>Tanggal Pelatihan: </span>
                                        <input type="date" v-model="form.editedItem.tanggal"
                                            style="border: 1px solid grey;" />
                                    </v-col>
                                    <v-col cols="6" v-if="form.editedIndex == -1">
                                        <span>Pilih File Sertifikat: </span>
                                        <input type="file" label="Sertifikat:" @change="fileChange" ref="file" accept="application/pdf" />
                                        <br/><span class="error--text">* Format .pdf, Ukuran maksimal 1mb</span>
                                    </v-col>
                                    <v-col v-else cols="6">
                                        <a :href="form.editedItem.file_url" target="_blank">Lihat
                                            File</a>
                                        <br /><br /><span>Pilih File Sertifikat untuk mengedit file: </span>
                                        <input type="file" label="Sertifikat:" @change="fileChange" ref="file" accept="application/pdf" />
                                        <br/><span class="error--text">* Format .pdf, Ukuran maksimal 1mb</span>
                                    </v-col>

                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary" @click="save()">
                                    Simpan
                                </v-btn>
                                <v-btn color="secondary" @click="cancel()">
                                    Batal
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.tanggal="{ item }">
                {{ formatDate(item.tanggal) }}
            </template>
            <template v-slot:item.sertifikat="{ item }">
                <a :href="item.file_url" target="_blank">Lihat File</a>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="editItem(item)">
                    {{ icons.mdiPencil }}
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn x-small color="primary" @click="getDataFromApi()">
                    Reload
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiDelete, mdiPencil } from '@mdi/js'
import UploadDokumenRegistrasi from '@/components/upload/UploadDokumenRegistrasi.vue'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
    components: {
        UploadDokumenRegistrasi,
    },
    data() {
        return {
            praktik_id: this.$route.params.praktik_id,
            data: {
                nama_institusi: '',
                nama_prodi: '',
                profesi: '',
                stase: '',
                tanggal_awal: '',
                tanggal_akhir: '',
            },
            icons: {
                mdiDelete,
                mdiPencil,
            },
            tableOptions: {},
            table: {
                loading: true,
                headers: [
                    { text: 'No', align: 'start', sortable: false, value: 'no', },
                    { text: 'Nama', value: 'nama', sortable: false },
                    { text: 'NIP', value: 'nip', sortable: false },
                    { text: 'Masa Kerja', value: 'masa_kerja', sortable: false },
                    { text: 'Pelatihan/Seminar/Workshop', value: 'ijazah', sortable: false },
                    { text: 'Nomor Sertifikat', value: 'sip', sortable: false },
                    { text: 'Tanggal Pelatihan', value: 'tanggal', sortable: false },
                    { text: 'Sertifikat', value: 'sertifikat', sortable: false },
                    { text: '', value: 'actions', sortable: false },
                ],
                items: [],
                totalItems: 0,
            },
            dialog: false,
            form: {
                editedIndex: -1,
                file_temp: '',
                editedItem: {
                    nama: '',
                    nip: '',
                    masa_kerja: '',
                    id_dokdiknis: '',
                    ijazah: '',
                    sip: '',
                    // str: '',
                    tanggal: '',
                    sertifikat: '',
                },
                defaultItem: {
                    nama: '',
                    nip: '',
                    masa_kerja: '',
                    id_dokdiknis: '',
                    ijazah: '',
                    sip: '',
                    // str: '',
                    tanggal: '',
                    sertifikat: '',
                },
                dokdikniss: [],
            },
        }
    },
    watch: {
        tableOptions: {
            handler() {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    computed: {
        formTitle() {
            return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
        },
    },
    created() {
        this.getPilihanDokdiknis()
    },
    methods: {
        fileChange() {
            this.form.file_temp = this.$refs.file.files.item(0)
        },
        save() {
            if (this.form.editedIndex > -1) {
                const fmData = new FormData()
                fmData.append('aksi', 'edit')
                fmData.append('id', this.form.editedItem.id)
                fmData.append('nama', this.form.editedItem.nama)
                fmData.append('nip', this.form.editedItem.nip)
                fmData.append('masa_kerja', this.form.editedItem.masa_kerja)
                fmData.append('dokdiknis', this.form.editedItem.id_dokdiknis)
                fmData.append('ijazah', this.form.editedItem.ijazah)
                fmData.append('sip', this.form.editedItem.sip)
                // fmData.append('str', this.form.editedItem.str)
                fmData.append('tanggal', this.form.editedItem.tanggal)
                fmData.append('old_file_name', this.form.editedItem.sertifikat)
                if (this.form.file_temp != undefined) {
                    fmData.append('sertifikat', this.form.file_temp)
                }
                axiosPostAuth('api/Pembimbing/addPengembangan', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                            this.dialog = false
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            } else {
                const fmData = new FormData()
                fmData.append('aksi', 'add')
                fmData.append('nama', this.form.editedItem.nama)
                fmData.append('nip', this.form.editedItem.nip)
                fmData.append('masa_kerja', this.form.editedItem.masa_kerja)
                fmData.append('dokdiknis', this.form.editedItem.id_dokdiknis)
                fmData.append('ijazah', this.form.editedItem.ijazah)
                fmData.append('sip', this.form.editedItem.sip)
                // fmData.append('str', this.form.editedItem.str)
                fmData.append('tanggal', this.form.editedItem.tanggal)
                if (this.form.file_temp != undefined) {
                    fmData.append('sertifikat', this.form.file_temp)
                }
                axiosPostAuth('api/Pembimbing/addPengembangan', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                            this.dialog = false
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            }
        },
        getDataFromApi() {
            const { page, itemsPerPage } = this.tableOptions
            const fmData = new FormData()
            fmData.append('page', page)
            fmData.append('itemsPerPage', itemsPerPage)
            fmData.append('search', '')
            axiosPostAuth('api/Pembimbing/getPengembangan_datatable', fmData)
                .then(response => {
                    this.table.items = response.data
                    this.table.totalItems = response.total
                    this.table.loading = false
                })
                .catch(error => {
                    alert(error)
                })
        },
        add() {
            this.form.editedItem = Object.assign({}, this.form.defaultItem)
            this.form.editedIndex = -1
        },
        editItem(item) {
            this.form.editedIndex = this.table.items.indexOf(item)
            this.form.editedItem = Object.assign({}, item)
            if (this.$refs.file) {
                this.$refs.file.value = null
            }

            this.dialog = true
        },
        // deleteItem(item) {
        //     const conf = confirm("Apakah yakin akan dihapus?")
        //     if (conf) {
        //         const fmData = new FormData()
        //         fmData.append('id', item.id)
        //         axiosPostAuth('api/Praktik/deleteUserPraktik', fmData)
        //             .then(response => {
        //                 if (response.code === 200) {
        //                     this.getDataFromApi()
        //                 }
        //                 else {
        //                     alert(response.message)
        //                 }
        //             })
        //             .catch(error => {
        //                 alert(error)
        //             })
        //     }
        // },
        getPilihanDokdiknis() {
            axiosGetAuth(`api/RegisterLanjutan/getPilihanDokdiknis`)
                .then(response => {
                    if (response.code === 200) {
                        this.form.dokdikniss = response.datas
                    } else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        cancel() {
            this.form.file_temp = ''
            this.$refs.file.value = null;
            this.dialog = false
        },
    },
}
</script>